import axios from 'axios';

export default () => {

    //load more for tables of: Reports, Presentations, Awards, Documents

    let loadMoreButton = document.getElementById("more_cpts"),
        loadMoreCardButton = document.getElementById("more_posts"),
        pageNumber = 1,
        pageNumberCard = 0;

//load more for tables of: Reports, Presentations, Awards, Documents
    function LoadMoreCPT(el) {

        let e = el.target,

            tax = e.getAttribute("data-tax") ? e.getAttribute("data-tax") : '',
            year = e.getAttribute("data-year") ? e.getAttribute("data-year") : '',
            type = e.getAttribute("data-type") ? e.getAttribute("data-type") : '',
            ppp = e.getAttribute("data-ppp") ? e.getAttribute("data-ppp") : '',

            pages = e.getAttribute("data-pages"),
            cpt = e.getAttribute("data-cpt"),

            offset = pageNumber * ppp,
            data = new URLSearchParams();

        data.append('action', 'more_cpt_post_ajax');
        data.append('offset', offset);
        data.append('year', year);
        data.append('ppp', ppp);
        data.append('cpt', cpt);
        data.append('tax', tax);
        data.append('type', type);


        let tbody = document.getElementById('reports_list').getElementsByTagName('tbody');

        axios.post(ajaxurl, data)
            .then(function (response) {

                // console.log(response.data);

                pageNumber++;

                tbody[0].insertAdjacentHTML('beforeend', response.data);

                var pagesNum = parseInt(pages, 10);
                if (pageNumber === pagesNum) {
                    document.getElementById("more_cpts").style.display = "none";
                    document.getElementById("more_cpts").style.visibility = 'hidden';

                }

            })
            .catch(function (error) {
                console.log(error);
            });

    }

//Load more for Announcements cards.
// Different logic, the first time we load the same cards again
    function LoadMoreCardCPT(el) {

        let e = el.target,

            // tax = e.getAttribute("data-tax"),
            pages = e.getAttribute("data-pages"),
            ppp = e.getAttribute("data-ppp"),
            cpt = e.getAttribute("data-cpt"),
            offset = pageNumberCard * ppp,
            data = new URLSearchParams();

        // console.log(pageNumber)

        data.append('action', 'more_post_ajax');
        data.append('offset', offset);
        data.append('ppp', ppp);
        data.append('cpt', cpt);
        // data.append('tax', tax);

        let wrapper = document.getElementById('ajax-posts');

        axios.post(ajaxurl, data)
            .then(function (response) {

                // console.log(response.data);

                pageNumberCard++;

                wrapper.insertAdjacentHTML('beforeend', response.data);

                var pagesNum = parseInt(pages, 10);

                if (pageNumberCard === pagesNum) {
                    loadMoreCardButton.style.display = "none";

                }

            })
            .catch(function (error) {
                console.log(error);
            });

    }

    if (loadMoreButton) {
        loadMoreButton.onclick = LoadMoreCPT;

    }

    if (loadMoreCardButton) {
        loadMoreCardButton.onclick = LoadMoreCardCPT;
    }


    function filterReports(el) {

        let pageNumber = 0,
            e = el.target,
            tax = e.getAttribute("data-tax") ? e.getAttribute("data-tax") : '',
            year = e.getAttribute("data-year") ? e.getAttribute("data-year") : '',
            type = e.getAttribute("data-type") ? e.getAttribute("data-type") : '',
            ppp = e.getAttribute("data-ppp") ? e.getAttribute("data-ppp") : '';

        let offset = pageNumber * ppp;
        let data = new URLSearchParams();

        data.append('action', 'filter_reports');
        data.append('offset', offset);
        data.append('ppp', ppp);
        data.append('year', year);
        data.append('type', type);
        data.append('tax', tax);

        let tbody = document.getElementById('reports_list').getElementsByTagName('tbody');

        axios.post(ajaxurl, data)
            .then(function (response) {

                console.log(response.data['pages']);

                tbody[0].innerHTML = response.data['posts'];

                let pages = response.data['pages'];
                loadMoreButton.setAttribute('data-pages', pages);

                pageNumber++

                //TODO

                var pagesNum = parseInt(pages, 10);
                if (pageNumber === pagesNum ) {
                    document.getElementById("more_cpts").style.display = "none";
                    document.getElementById("more_cpts").style.visibility = 'hidden';
                } else {
                    document.getElementById("more_cpts").style.display = "block";
                    document.getElementById("more_cpts").style.visibility = 'visible';
                }

            })
            .catch(function (error) {
                console.log(error);
            });

    }

    function setType(choosedButton, changeButton){
        if (choosedButton.getAttribute('data-type')) {
            changeButton.setAttribute('data-type', choosedButton.getAttribute('data-type'));
            // changeButton.removeAttribute('data-tax');
        }

        if (choosedButton.getAttribute('data-type-all')) {
            changeButton.removeAttribute('data-type');
            changeButton.setAttribute('data-tax', choosedButton.getAttribute('data-tax'));
        }
    }

    function setYear(choosedButton, changeButton){
        if (choosedButton.getAttribute('data-year')) {
            changeButton.setAttribute('data-year', choosedButton.getAttribute('data-year'));
        }

        if (choosedButton.getAttribute('data-year-all')) {
            changeButton.removeAttribute('data-year');
        }
    }


    if (document.querySelector('.report-filter-button')) {
        let filterButtonYear = document.querySelectorAll('.th-sel__body-list--year .report-filter-button');
        let filterButtonType = document.querySelectorAll('.th-sel__body-list--type .report-filter-button');

        filterButtonYear.forEach(button => {
            button.addEventListener('click', (el) => {
                let thisButton = button;

                filterReports(el);
                setType(thisButton, loadMoreButton);
                setYear(thisButton, loadMoreButton);

                filterButtonType.forEach(button => {
                    setYear(thisButton, button);
                });
            });
        });

        filterButtonType.forEach(button => {
            button.addEventListener('click', (el) => {
                let thisButton = button;

                filterReports(el);
                setType(thisButton, loadMoreButton);
                setYear(thisButton, loadMoreButton);

                filterButtonYear.forEach(button => {
                    setType(thisButton, button);
                });
            });
        });
    }
}